import React from 'react'
import PropTypes from 'prop-types'
import { Translate } from 'i18n'
import './style.css'


const RecipeSchemaLink = props => {
    const handleClick = (e) => {
        e.preventDefault()

        // add items once and clear storage
        props.items.forEach(item => props.createItem(item))
        props.setWrapperRecipeSchemaItems([])
    }

    if (!props.isVisible) {
        return null
    }

    return (
        <button
            className='button button_type_primary button_size_small button_type_wide recipe-schema-link'
            onClick={handleClick}>
            <Translate value='saveItemsFromRecipe' />
        </button>
    )
}

RecipeSchemaLink.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    setWrapperRecipeSchemaItems: PropTypes.func.isRequired,
    createItem: PropTypes.func.isRequired
}

export default RecipeSchemaLink
